import React from 'react';
import './PartnersLogo.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { images } from '../../assets';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none"}}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none"}}
      onClick={onClick}
    />
  );
}

function PartnersLogo({className}) {

  const settings = {
    
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 2000,
          cssEase: "linear",
          infinite: true,
          dots: false
        }
      },
    ]
  };


  return (
    <div className={className}>
      <div className='slider-container'>
      <Slider {...settings}>

          <div className='comLogo'>
          <img src={images.sbi} alt='sbi' />
          </div>
          <div className='comLogo'>
          <img src={images.alkem} alt='alkem' />
          </div>
          <div className='comLogo'>
          <img src={images.hdfc} alt='hdfc' />
          </div>
          <div className='comlogo'>
            <img src={images.mahindra} alt='mahindra' />
          </div>
          <div className='comLogo'>
            <img src={images.suzlon} alt='suzlon' />
          </div>
          <div className='comLogo'>
            <img src={images.nmdc} alt='nmdc' />
          </div>
          <div className='comLogo'>
            <img src={images.accenture} alt='accenture' />
          </div>
          <div className='comLogo'>
            <img src={images.marico} alt='marico' />
          </div>
          <div className='comLogo'>
            <img src={images.schlumberger} alt='schlumberger' />
          </div>
          <div className='comlogo'>
            <img src={images.avanse} alt='avanse' />
          </div>
          <div className='comLogo'>
            <img src={images.idfc} alt='idfc' />
          </div>
          <div className='comlogo'>
            <img src={images.uno} alt='uno' />
          </div>
          <div className='comlogo'>
            <img src={images.jll} alt='jll' />
          </div>
          <div className='comlogo'>
            <img src={images.aadhar} alt='aadhar' />
          </div>
          <div className='comLogo'>
            <img src={images.crompton} alt='crompton' />
          </div>
          <div className='comlogo'>
            <img src={images.vedantalogo} alt='vedanta' />
          </div>
          <div className='comlogo'>
            <img src={images.pantaloons} alt='pantaloons' />
          </div>
          <div className='comlogo'>
            <img src={images.thermofisher} alt='thermofisher' />
          </div>
          <div className='comlogo'>
            <img src={images.arcesium} alt='arcesium' />
          </div>
          </Slider>
      </div>
    </div>
  );
}

export default PartnersLogo;